import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Button,
  TextField,
  Container,
  Box,
  InputAdornment,
  IconButton,
  Theme, Grid, Typography 
} from '@material-ui/core/';
import * as actions from "../../../../store/actions/index";
import moment from "moment";
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles'
import {Styles} from "@material-ui/core/styles/withStyles";
import CancelIcon from '@material-ui/icons/ClearSharp';
import Alert from '@material-ui/lab/Alert';
import {Helmet} from "react-helmet";
import ReactHtmlParser, {processNodes} from "react-html-parser"
import { Loading } from '../../../atoms/commonLoadings';
import clsx from 'clsx';
import Config from "../../../../config/config";


const useStyles: Styles<Theme, any, any> = () => ({
  appBar: {
    position: 'relative',
    background: 'none',
    boxShadow: 'none',
  },
  toolBar: {
    minHeight: 50,
  },
  layout: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: '20px',
    paddingRight: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: '#6667ab',
    width: '100vw',
    backgroundImage: 'url(/assets/images/known/confirm_header.png)',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom'
  },
  label: {
    color: '#f2f2fa',
    "&$focusedLabel": {
      color: "#fdca42"
    },
    "&$erroredLabel": {
      color: "#fdca42"
    }
  },
  focusedLabel: {},
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#f2f2fa',
    "&$error:after": {
      borderBottomColor: "#fdca42"
    },
    "&:after": {
      borderBottom: `2px solid #fdca42`
    }
  },
  error: {},

  textCenter: {
    textAlign: 'center',
    color: '#f2f2f2'
  },
  headline: {
    '@media (max-width: 960px)': {
      fontSize: '3.5rem',
    },
    '@media (max-width: 600px)': {
      fontSize: '2.5rem',
    },
  },
  logoFont: {
    fontFamily: 'Pacifico',
    color: '#fdca42'
  },

  actionButtons: {
    marginTop: '20px',
    minWidth: '460px',
    marginBottom: '20px',
    '@media (max-width: 760px)': {
      minWidth: '250px'
    },
    color: '#fdca42',
    border: '1px solid rgba(253, 202, 66, 0.5)',
    '&:hover': {
			border: '1px solid #fdca42',
      backgroundColor: 'rgba(253, 202, 66, 0.04)'
		},
  },

  passwordCheckRow: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    fontWeight: 300,
    fontFamily: 'roboto-regular',
    textAlign: "left",
  },
  passwordInput: {
    width: '100%',
    "& .MuiInputAdornment-positionEnd": {
      margin: "0!important",
    }
  },
  registerlogocontainer:{
    textAlign:"left", 
    marginTop:"22px", 
    marginLeft:"40px",
    '@media (max-width: 768px)': {
      margin:"0 auto",
      paddingTop:"20px",
      textAlign:"center", 
      width:"100%"
    },
  },
  registerLogo:{
    width: "188px",
    height: "27px",
    '@media (max-width: 768px)': {
      width:"100%"
    },
  },
  description_smart:{
    textAlign:"center",
    font: "normal normal bold 24px/26px Spartan-bold",
    color: "#017AEF",
  },
  description2:{
    textAlign:"center",
    font: "normal normal bold 24px/26px Spartan-bold",
    color: "#2D2D2D",
    opacity: "1",
    marginBottom: "10px"
  },
  //general
  bottomleft:{
    textAlign:"left",
    '@media (max-width: 960px)': {
      textAlign:"center"
    },
  },
  bottomimageleft:{
    width: "354px",
    height: "161px",
    marginTop:"140px",
    marginLeft:"30px",
    '@media (max-width: 767px)': {
      margin:"0 auto",
      maxWidth: "354px",
      width:"100%"
    },
  },
  bottomright:{
    textAlign:"right",
    '@media (max-width: 960px)': {
      textAlign:"center",
    },
  },
  bottomimageright:{
    width: "374px",
    // height: "260px",
    marginRight:"30px",
    '@media (min-width: 768px) and (max-width:992px)': {
      marginRight:"0",
    },
    '@media (max-width: 767px)': {
      margin:"0 auto",
      width:"100%",
      maxWidth: "374px",
    },
  },
});

interface IProps {
  apolloClient: any,
  notification: any,
  authUser: any,
  classes: any,
  history: any,
  confirmUser: (client: any, request: any) => void,
  ResendLink: (client: any, request: any) => void
  myPassReset: (client: any, obj: any, history: any) => void
}

interface IState {
  newPassword: string,
  newPasswordAgain: string,
  error: any,
  errorMessage: any,
  isPasswordShown: boolean,
  isPasswordShownAgain: boolean,
  code: string,
  username: string,
  clientId: string,
  region: string,
  email: string,
  is_loaded: boolean,
  is_length: boolean,
  is_lowercase: boolean,
  is_uppercase: boolean,
  is_number: boolean,
  // is_special_character: boolean,
  is_confirm: boolean,
  is_page: boolean,
  is_validlink: boolean,
  errors: any,
  loading: boolean,
  expiredin: string,
  [key: string]: any,
  errorMsg:string,
  pageLoading:boolean
}

class CreatePassword extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      newPassword: "",
      newPasswordAgain: "",
      error: [],
      errorMessage: [],
      isPasswordShown: true,
      isPasswordShownAgain: true,
      code: "",
      username: "",
      clientId: "",
      region: "",
      email: "",
      is_loaded: false,
      is_length: false,
      is_lowercase: false,
      is_uppercase: false,
      is_number: false,
      // is_special_character: false,
      is_confirm: false,
      is_page: true,
      is_validlink: true,
      errors: {},
      loading: false,
      expiredin: "",
      errorMsg:"",
      pageLoading:true
    };
  }

  // get data from url 
  getQueryString = (field: any, url?: any) => {
    const href = url ? url : window.location.href;
    const reg = new RegExp("[?&]" + field + "=([^&#]*)", "i");
    const string = reg.exec(href);
    return string ? string[1] : null;
  };

  // load init data
  componentDidMount() {
    // const exptime = moment().utc().valueOf() + (1000 * 60 * 5);
    this.setState(
      {
        code: this.getQueryString("code") || "",
        username: this.getQueryString("username") || "",
        clientId: this.getQueryString("clientId") || "",
        region: this.getQueryString("region") || "",
        email: this.getQueryString("email") || "",
        expiredin: this.getQueryString("expiredin") || "",
      },
      () => {
        this.forceUpdate();
        if (this.state.expiredin) {
          if (moment().utc().valueOf() > Number(this.state.expiredin)) {
            this.setState({ is_validlink: false });
          }
        }
        const request = {
          email: this.state.email
        }
        this.props.confirmUser(this.props.apolloClient.client, request)
      }
    );
  }

  // when receive update from reducer
  UNSAFE_componentWillReceiveProps(props: IProps) {
    if (props.notification) {
      this.setState({ loading: false, pageLoading: false })
    }
    if(props.notification.message && !props.notification.success) {
      this.setState({
        errorMsg: props.notification.message
      })
    }
    if(props.authUser){
      this.setState({
        pageLoading: false
      })
      if(props.authUser.passwordCreated){
        this.props.history.push("/user/login")
      }
    }
  }

  // show password
  togglePasswordVisibility = () => {
    const { isPasswordShown } = this.state;
    this.setState({ isPasswordShown: !isPasswordShown });
  };

  // show repeat password
  togglePasswordVisibilityForAgain = () => {
    const { isPasswordShownAgain } = this.state;
    this.setState({ isPasswordShownAgain: !isPasswordShownAgain });
  };

  // resend link
  resendLink = () => {
    this.setState({ loading: true });
    if (this.state.email) {
      this.setState({ loading: true });
      const request = {
        email: this.state.email,
        brand: Config.DEFAULT_SUBBRAND,
      }
      this.props.ResendLink(this.props.apolloClient.client, request)
    }
  }

  // validation for confirm password
  validateConfirmPassword = (event: any) => {
    const fieldValue = event.target.value;
    if (fieldValue.length !== 0) {
      this.setState({
        newPasswordAgain: event.target.value,
      });
      const x = this.state.newPassword;
      if (x === fieldValue) {
        this.setState({
          is_confirm: true,
        });
      } else {
        this.setState({
          is_confirm: false,
        });
      }
    }
  };

  // validation for new password
  validateNewPassword = (event: any) => {
    const fieldValue = event.target.value;
    this.setState({
      newPassword: event.target.value,
    });
    if (fieldValue === this.state.newPasswordAgain) {
      this.setState({ is_confirm: true, });
    } else { this.setState({ is_confirm: false }); }
    const rules = [
      {
        Pattern: "[A-Z]",
        Target: "UpperCase",
      },
      {
        Pattern: "[a-z]",
        Target: "LowerCase",
      },
      {
        Pattern: "[0-9]",
        Target: "Numbers",
      },
      // {
      //   Pattern: "[ .!@#$%^&*|]",
      //   Target: "SpecialCharacter",
      // },
    ];
    if (fieldValue.length > 7) {
      this.setState({
        is_length: true,
      }, () => {
        this.forceUpdate();
      });
    } else {
      this.setState({
        is_length: false,
      }, () => {
        this.forceUpdate();
      });
    }

    for (let i = 0; i < rules.length; i++) {
      if (new RegExp(rules[i].Pattern).test(fieldValue)) {
        if (rules[i].Target === "UpperCase") {
          this.setState({
            is_uppercase: true,
          });
        } else if (rules[i].Target === "LowerCase") {
          this.setState({
            is_lowercase: true,
          });
        } else if (rules[i].Target === "Numbers") {
          this.setState({
            is_number: true,
          });
        }
        //  else if (rules[i].Target === "SpecialCharacter") {
        //   this.setState({
        //     is_special_character: true,
        //   });
        // }
      }
      if (!new RegExp(rules[i].Pattern).test(fieldValue)) {
        if (rules[i].Target === "UpperCase") {
          this.setState({
            is_uppercase: false,
          });
        } else if (rules[i].Target === "LowerCase") {
          this.setState({
            is_lowercase: false,
          });
        } else if (rules[i].Target === "Numbers") {
          this.setState({
            is_number: false,
          });
        }
        //  else if (rules[i].Target === "SpecialCharacter") {
        //   this.setState({
        //     is_special_character: false,
        //   });
        // }
      }
    }
  };

  // when submit password form
  handleSubmit = (e: any) => {
    e.preventDefault()
    const errors: any = {}
    // if (this.state.newPassword === this.state.newPasswordAgain) {
      if (this.state.email) {
        const obj = {
          old_password: "TenantAccountP@ssword1!!",
          new_password: this.state.newPassword,
          email: this.state.email,
          is_page: this.state.is_page,
        };
        this.setState({ loading: true, errorMsg:""});
        this.props.myPassReset(this.props.apolloClient.client, obj, this.props.history);
      }
    // } else {
    //   errors.passwordNotMatched = "Password Not matched"
    // }
    this.setState({ errors: errors })
  };

  // when change field
  onChange = (event: any) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  transform = (node: any, index: any) => {
    if (node.type === "tag" && node.name === "span") {
      return (
        <span style={{ cursor: "pointer" }} key={index}>
          { processNodes(node.children, this.transform) }
        </span>
      );
    }
  }


  render() {
    const {
      errors,
      loading,
      is_number,
      is_lowercase,
      is_uppercase,
      is_length,
      // is_special_character,
      isPasswordShown,
      errorMsg
    } = this.state;
    const { classes } = this.props;
    const normalBtn = { marginTop: 30, backgroundColor: "#017AEF" };

    const options = {
      decodeEntities: true,
      transform: this.transform
    };


    return (
      <React.Fragment>
        <Helmet title="Create Password"/>
        {this.state.pageLoading ? 
        <Container component="main" className={classes.layout}>
          <Loading />
          </Container> 
          : <> 

        
        <div className={classes.layout}>
        <Grid container spacing={3}>
              <Grid item xs={12} sm={6} >

          <Box className="">

          <Typography variant="h1" component="h1" className={clsx(classes.textCenter, classes.headline)}>Set a password <span className={classes.logoFont}>known</span> only to yourself.</Typography>

            <div className="login-form">
              <form noValidate onSubmit={this.handleSubmit}>
                {this.state.is_validlink ? (
                  <>
                    <TextField
                      InputLabelProps={{
                        classes: {
                          root: classes.label,
                          focused: classes.focusedLabel,
                          error: classes.erroredLabel
                        },
                      }}
                      InputProps={{
                        classes: {
                          root: classes.underline,
                          error: classes.error
                        },
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              className="password-visible-btn"
                              onClick={this.togglePasswordVisibility}
                              aria-label="toggle password visibility"
                            >
                              {
                                !this.state.isPasswordShown ? <img src='/assets/images/eye-show-visible.svg' alt="show"/>
                                  : <img src='/assets/images/eye-hidden.svg' alt="hidden"/>
                              }
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                      className={classes.passwordInput}
                      margin="normal"
                      id="newPassword"
                      label="Create Password (required)*"
                      type={isPasswordShown ? "password" : "text"}
                      name="newPassword"
                      onChange={this.validateNewPassword}
                      value={this.state.newPassword}
                      // onChange={this.onChange}
                      error={errors && errors.validpassword ? true : false}
                    />
                    <div className={classes.passwordCheckRow}>
                      {is_length ? "" : <><CancelIcon style={{ marginRight: 10 }} color="error" /> Password must be at least 8 characters</> }
                    </div>
                    <div className={classes.passwordCheckRow}>
                      {is_number ? "" : <><CancelIcon style={{ marginRight: 10 }} color="error" /> Password must contain at least one number </>}
                    </div>
                    {/* <div className={classes.passwordCheckRow}>
                      {is_special_character ? <><CheckCircleOutlineIcon style={{ color: green[500], marginRight: 10 }} /> : <CancelIcon style={{ marginRight: 10 }} color="error" /> Password must contain at least one symbol </>}
                    </div> */}
                    <div className={classes.passwordCheckRow}>
                      {is_uppercase ? "" : <><CancelIcon style={{ marginRight: 10 }} color="error" /> Password must contain at least one upper-case letter </>}
                    </div>
                    <div className={classes.passwordCheckRow}>
                      {is_lowercase ? "" : <><CancelIcon style={{ marginRight: 10 }} color="error" /> Password must contain at least one lower-case letter </>}
                    </div>
                    

                    
                      <Button
                        type="submit"
                        variant="outlined"
                        color="secondary"
                        className={classes.actionButtons}
                        
                        disabled={loading || !(is_length && is_number && is_uppercase && is_lowercase )}
                      >
                        {loading && <CircularProgress color="inherit" size={20}/>}
                        {!loading && <p style={(is_length && is_number && is_uppercase && is_lowercase ) ? {} : {}}>Save</p>}
                      </Button>
                  </>
                ) : (
                  <>
                  <Alert icon={false} className="error-alert" severity="error">This link is expired, Please click below button to resend email.</Alert>
                  <Button
                    type="button"
                    className="btn-register-with"
                    style={ normalBtn }
                    disabled={loading}
                    onClick={() => { this.resendLink() }}
                  >
                    {loading && <CircularProgress color="inherit" size={20}/>}
                    {!loading && <p>Resend Email</p>}
                  </Button>
                  </>
                )}
                <br/><br/>
                { errorMsg && <Alert style={{width:"100%"}} icon={false} className="error-alert" severity="error">{ ReactHtmlParser(errorMsg, options) }</Alert> }
              </form>
            </div>
          </Box>
          </Grid>
              </Grid>
        </div>
        
        </>}
      </React.Fragment>
    );
  }
}

// load reducers
const mapStateToProps = (state: any) => ({
  authUser: state.authUser,
  apolloClient: state.apolloClient,
  notification: state.notification
});

// load actions
const mapDispatchToProps = (dispatch: any) => {
  return {
    myPassReset: (client: any, request: any, history: any) => {
      dispatch(actions.myPassReset(client, request, history));
    },
    ResendLink: (client: any, request: any) => {
      dispatch(actions.ResendLink(client, request));
    },
    confirmUser: (client: any, request: any) => {
      dispatch(actions.confirmUser(client, request));
    }
  }
};

const KnownCreatePasswordComponent = withStyles(useStyles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(CreatePassword));

export {
  KnownCreatePasswordComponent
}
